import uuid from 'react-uuid';
import { CRMModelVariants } from '../models';

const STORE_KEY = 'CRMModelVariants';

function removeDuplicatesByID(items: CRMModelVariants[]): CRMModelVariants[] {
  const seenIDs = new Set<string>();
  const result: CRMModelVariants[] = [];

  for (const item of items) {
    if (!seenIDs.has(item.variantPimIdentifier)) {
      seenIDs.add(item.variantPimIdentifier);
      result.push(item);
    }
  }

  return result;
}

export const setCompareRangeSelectedVariants = (
  variants: CRMModelVariants[]
) => {
  variants.forEach((v) => {
    v.id = uuid();
  });

  const jsonData = JSON.stringify(
    removeDuplicatesByID(variants).sort((a, b) => a._order - b._order)
  );

  localStorage.setItem(STORE_KEY, jsonData);
};

export const getCompareRangeSelectedVariants = (): CRMModelVariants[] => {
  const data = localStorage.getItem(STORE_KEY);
  if (!data) return [];
  const parsedData = JSON.parse(data);
  return parsedData;
};
